<div class="group-row-content">
    <span class="button-content left-padding"><button (click)="click($event)" class="button button-no-margin">{{buttonText}}</button></span> <span class="left-padding" [ngClass]="{ 'bold' : boldLabel }">{{labelText}} </span>
</div>
